import { render, staticRenderFns } from "./PlantUserCreate.vue?vue&type=template&id=2af4b38f&"
import script from "./PlantUserCreate.vue?vue&type=script&lang=js&"
export * from "./PlantUserCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports